<template>
  <LinkButton
    tag="button"
    type="button"
    secondary
    small-padding
    class="filter-tag"
    @click="onClick"
  >
    <slot>{{ label }}</slot>

    <SvgIcon
      :image="deleteIcon"
      class="icon filter-tag__close-icon"
    />
  </LinkButton>
</template>

<script>
import deleteIcon from '@/assets/images/delete-filter-tag.svg';
import { LinkButton } from '@i22-td-smarthome/component-library';

export default {
  name: 'FilterTag',
  components: { LinkButton },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
  },
  emits: ['click'],
  data() {
    return { deleteIcon };
  },
  methods: {
    onClick() {
      this.$emit('click', this.value, this.label);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.filter-tag {
  height: 24px;
  font-size: 0.8rem;
  line-height: 0.8rem;

  &__close-icon {
    margin-left: 10px;
  }
}
</style>
